import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { concatMap, forkJoin, from, of, tap } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { PaginationService } from 'src/app/PaginationService';

export interface Training {
  trainingName?: string;
  groupId?: number | string | null;
  trainingLevel?: number | null;
  trainingTemplate?: string | null;
  dueNDayFromAssigned?: number | null;
  remindNDayBeforeDue?: number | null;
  remindEveryNDays?: number | null;
  escalate?: boolean;
  escalateEveryNDays?: number | null;
  repeatTraining?: boolean;
  repeatInterval?: number | null;
  repeatIntervalUnit?: string | null;
  allowedFailedAttempts?: number | null;
  allowedFailedAttemptsAfterUnlock?: number | null;
  maxAllowedFailedAttempts?: number | null;
  dueNDayFromOverdueUnlock?: number | null;
  retakeAfterNMinOnFailedAttempt?: number | null;
  allowToReviewResults?: boolean;
  showAnswersAtReview?: boolean;
  overdueRmApprovalReqd?: boolean;
  overdueQaApprovalReqd?: boolean;
}

export const RESET_TRAINING: Training = {
  trainingLevel: 1,
  trainingTemplate: null,
  dueNDayFromAssigned: null,
  remindNDayBeforeDue: null,
  remindEveryNDays: null,
  escalate: false,
  escalateEveryNDays: null,
  repeatTraining: false,
  repeatInterval: null,
  repeatIntervalUnit: null,
  allowedFailedAttempts: null,
  allowedFailedAttemptsAfterUnlock: null,
  maxAllowedFailedAttempts: null,
  dueNDayFromOverdueUnlock: null,
  retakeAfterNMinOnFailedAttempt: null,
  allowToReviewResults: false,
  showAnswersAtReview: false,
  overdueRmApprovalReqd: false,
  overdueQaApprovalReqd: false,
};

@Component({
  selector: 'app-assign-training',
  templateUrl: './assign-training.component.html',
  styleUrls: ['./assign-training.component.scss']
})

export class AssignTrainingComponent implements OnInit {

  @Output() popupClosed = new EventEmitter<void>();

  isProcessing: boolean = false;

  training: Training = {};
  draftTraining: any = {};
  snackbarRef: any;

  labelList: any = [];
  trainingsList: any = [];
  headerList: any = [];
  rowList: any = [];
  tempTrainingArray: any = [];
  trainingArray: any = []

  searchCriteriaOptions: any = ['One training → Multiple groups', 'Multiple trainings → One group'];
  selectedTrainingCriteria: any;
  trainingLevelList: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  changeInCriteria: boolean = false;

  trainingTemplateList: any = [];
  repeatIntervalList: any = [];
  qaUsersList: any = [];
  categoryList: any = [];
  languageList: any = [];
  groupList: any = [];

  trainingLevelDropdown: any = [];
  trainingTemplateDropdown: any = [];
  repeatIntervalDropdown: any = [];
  qaDropdown: any = [];
  categoryDropdown: any = [];
  languageDropdown: any = [];
  groupDropdown: any = [];

  selectedQaUsers: any = [];
  selectedGroupIds: any = [];

  trainingLevelSearchText: string = '';
  trainingTemplateSearchText: string = '';
  repeatIntervalSearchText: string = '';
  qaSearchText: string = '';
  categorySearchText: string = '';
  languageSearchText: string = '';
  groupSearchText: string = '';

  popupTitle: string = '';
  operationFlag: string = '';
  selectedGroupName: string = '';

  searchByTrainingName: any = null;
  searchByTrainingCode: any = null;
  searchByCategory: any = null;
  searchByLanguage: any = null;
  dynamicLabel: any = null;

  parentCheckBox: boolean = false;
  showAssignedGroups: boolean = false;

  constructor(
    public dialog: MatDialog,
    private readonly appService: AppService,
    public router: Router,
    private readonly snackBar: MatSnackBar,
    public message: messageService,
    public paginationService: PaginationService,
  ) { }

  public onSearchCriteriaChanged(criteria: any): void {
    this.resetPopup();
    this.resetSearchTrainingPopup();
  }

  ngOnInit() {

    const currentUrl = this.router.url;
    console.log(currentUrl);
    this.changeInCriteria = currentUrl == '/dashboard/addTraining';

    const obj = { tableName: "TMS_GROUP_TRAININGS_VW", moduleName: null, gridName: "GROUP_TRAININGS", groupId: 0, };

    this.isProcessing = true;

    const getTrainingTemplate$ = this.appService.getTmsTrainingParameterTemplateVwDetails();
    const getRepeatInterval$ = this.appService.getCodeListsByGroup("REPEAT_INTERVAL_UNIT");
    const getLanguage$ = this.appService.getCodeListsByGroup("TRAINING_LANGUAGE");
    const getQa$ = this.appService.getTmsQAUserList();
    const getCategory$ = this.appService.getCategoriesList();
    const getGroups$ = this.appService.getTmsGroupsVwDetails();
    const getDynamicLabel$ = this.appService.getreorderGirdColumnList(obj);

    forkJoin([
      getTrainingTemplate$,
      getRepeatInterval$,
      getLanguage$,
      getQa$,
      getCategory$,
      getGroups$,
      getDynamicLabel$
    ]).subscribe(([trainingTemplate, repeatInterval, language, qa, category, groups, dynamicLabel]) => {

      this.trainingTemplateList = trainingTemplate;
      this.selectBoxForTrainingTemplate();

      this.repeatIntervalList = repeatInterval;
      this.selectBoxForRepeatInterval();

      this.languageList = language;
      this.selectBoxForLanguage();

      this.qaUsersList = qa;
      this.selectBoxForQa();

      this.categoryList = category;
      this.selectBoxForCategory();

      this.groupList = groups;
      this.selectBoxForGroup();

      this.labelList = dynamicLabel;
      this.setDynamicLabel();

      this.selectBoxForTrainingLevel();
      this.isProcessing = false;
    });

  }

  private selectBoxForTrainingLevel(): void {
    this.trainingLevelDropdown = this.trainingLevelList?.map((level: any) => ({
      valueExp: level,
      displayExp: level
    }))
  }

  public onLevelSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('level', item);
    }
  }

  private selectBoxForTrainingTemplate(): void {
    this.trainingTemplateDropdown = this.trainingTemplateList?.map((template: any) => ({
      valueExp: template.templateId,
      displayExp: template.templateName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onTemplateSelect(event: any, item: any): void {
    if (event.isUserInput) {
      if (item) {
        const template = this.trainingTemplateList?.find((t: any) => t.templateId == +item.valueExp);
        this.training.dueNDayFromAssigned = template.dueNDayFromAssigned;
        this.training.remindNDayBeforeDue = template.remindNDayBeforeDue;
        this.training.remindEveryNDays = template.remindEveryNDays;
        this.training.escalateEveryNDays = template.escalateEveryNDays;
        this.training.repeatInterval = template.repeatInterval;
        this.training.repeatIntervalUnit = template.repeatIntervalUnit;
        this.training.allowedFailedAttempts = template.allowedFailedAttempts;
        this.training.allowedFailedAttemptsAfterUnlock = template.allowedFailedAttemptsAfterUnlock;
        this.training.maxAllowedFailedAttempts = template.maxAllowedFailedAttempts;
        this.training.dueNDayFromOverdueUnlock = template.dueNDayFromOverdueUnlock;
        this.training.retakeAfterNMinOnFailedAttempt = template.retakeAfterNMinOnFailedAttempt;
        this.training.escalate = template.escalate == "Y";
        this.training.repeatTraining = template.repeatTraining == "Y";
        this.training.allowToReviewResults = template.allowToReviewResults == "Y";
        this.training.showAnswersAtReview = template.showAnswersAtReview == "Y";
        this.training.overdueRmApprovalReqd = template.overdueRmApprovalReqd == "Y";
        this.training.overdueQaApprovalReqd = template.overdueQaApprovalReqd == "Y";
        this.selectedQaUsers = template.listOfQaUsers ? template.listOfQaUsers.split(',').map((v: any) => Number(v.trim())) : [];
        setTimeout(() => { this.isAllQaSelected = this.qaDropdown.length == this.selectedQaUsers.length; })
      } else {
        this.training = { ...this.training, ...RESET_TRAINING };
      }
    }
  }

  private selectBoxForRepeatInterval(): void {
    this.repeatIntervalDropdown = this.repeatIntervalList?.map((template: any) => ({
      valueExp: template.codelistCode,
      displayExp: template.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  private selectBoxForQa(): void {
    this.qaDropdown = this.qaUsersList?.map((template: any) => ({
      valueExp: template.userId,
      displayExp: template.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onQaSelect(event: any, item: any): void {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('qa', this.selectedQaUsers);
        this.isAllQaSelected = this.qaDropdown.length == this.selectedQaUsers.length;
      })
    }
  }

  private selectBoxForCategory(): void {
    this.categoryDropdown = this.categoryList?.map((category: any) => ({
      valueExp: category.trainingCategoryCode,
      displayExp: category.trainingCategoryName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  private selectBoxForLanguage(): void {
    this.languageDropdown = this.languageList?.map((category: any) => ({
      valueExp: category.codelistCode,
      displayExp: category.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  private selectBoxForGroup(): void {
    this.groupDropdown = this.groupList?.map((group: any) => ({
      valueExp: group.groupId,
      displayExp: group.groupName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onGroupSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('group', item);
      if (item) {
        this.selectedGroupName = item.displayExp;
      } else {
        this.selectedGroupName = '';
      }
    }
  }

  public onMultiGroupSelect(event: any, user: any): void {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('group', this.selectedGroupIds);
        this.isAllGroupSelected = this.groupDropdown.length == this.selectedGroupIds.length;
      })
    }
  }

  private setDynamicLabel(): void {
    this.dynamicLabel = this.labelList?.reduce((acc: any, user: any) => {
      acc[`${user.columnName}`] = user.changedFieldName;
      return acc;
    }, {});
  }

  public onEscalateChange(): void {
    if (!this.training.escalate) {
      this.training.escalateEveryNDays = null;
    }
  }

  public onRepeatTrainingChange(): void {
    if (!this.training.repeatTraining) {
      this.training.repeatInterval = null;
      this.training.repeatIntervalUnit = null;
    }
  }

  public onAllowToReviewResultsChange(): void {
    if (!this.training.allowToReviewResults) {
      this.training.showAnswersAtReview = false;
    }
  }

  public onQaApprovalRequestedChange(): void {
    if (!this.training.overdueQaApprovalReqd) {
      this.selectedQaUsers = [];
    }
  }


  public focusSearch(value: any): void {
    setTimeout(() => {
      let requiredElement = document.getElementById(value); requiredElement?.focus();
    }, 0)
  };

  public validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  public handleDropDownValidation(fieldId: string, selectedItems: any[] | string): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId == 'group' && this.selectedTrainingCriteria == 'One training → Multiple groups') || fieldId == 'qa';
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const flag: boolean = this.selectedTrainingCriteria == 'One training → Multiple groups' ? items.length : items;

    field && (field.style.color = flag ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  @ViewChild('qa') qa: MatSelect;
  public isAllQaSelected: boolean = false;
  @ViewChild('group') group: MatSelect;
  public isAllGroupSelected: boolean = false;

  public toggleAllGroup(): void {
    if (this.isAllGroupSelected) {
      for (const item of this.group.options) item.select();
    } else {
      for (const item of this.group.options) item.deselect();
      this.selectedGroupIds = [];
    }

    setTimeout(() => { this.handleDropDownValidation('qa', this.selectedQaUsers); });
  }

  public toggleAllQa(): void {
    if (this.isAllQaSelected) {
      for (const item of this.qa.options) item.select();
    } else {
      for (const item of this.qa.options) item.deselect();
      this.selectedQaUsers = [];
    }

    setTimeout(() => { this.handleDropDownValidation('qa', this.selectedQaUsers); });
  }

  @ViewChild('assignPopup', { static: true }) assignPopup: TemplateRef<any>;
  private visibleAssignPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('searchTrainingPopup', { static: true }) searchTrainingPopup: TemplateRef<any>;
  private visibleSearchTrainingPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('assignedGroupPopup', { static: true }) assignedGroupPopup: TemplateRef<any>;
  private visibleAssignedGroupPopup: MatDialogRef<TemplateRef<any>>;

  private readonly assignPopupConfig: MatDialogConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  private readonly searchTrainingConfig: MatDialogConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  private readonly assignedGroupConfig: MatDialogConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  public openAddPopup(): void {
    this.operationFlag = 'ADD';
    this.popupTitle = "Assign Training";
    this.selectedTrainingCriteria = null;
    this.resetPopup();
    this.visibleAssignPopup = this.dialog.open(this.assignPopup, this.assignPopupConfig);
  }

  private resetPopup(): void {
    this.training = {};
    this.training.escalate = false;
    this.training.repeatTraining = false;
    this.training.allowToReviewResults = false;
    this.training.showAnswersAtReview = false;
    this.training.overdueRmApprovalReqd = false;
    this.training.overdueQaApprovalReqd = false;
    this.training.trainingLevel = 1;
    this.selectedGroupIds = [];
  }

  public resetSearchTrainingPopup(): void {
    [
      this.searchByTrainingName,
      this.searchByTrainingCode,
      this.searchByCategory,
      this.searchByLanguage,
      this.draftTraining,
      this.trainingsList,
      this.tempTrainingArray,
      this.trainingArray
    ] = [null, null, null, null, {}, [], [], []];
  }

  public get isAddDisabled(): boolean {
    if (this.selectedTrainingCriteria === 'One training → Multiple groups') {
      return this.draftTraining && Object.keys(this.draftTraining).length === 0;
    } else {
      return this.tempTrainingArray.length === 0;
    }
  }

  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  public openAssignedGroupsPopup(): void {
    this.isProcessing = true;
    [this.rowList, this.headerList, this.pagedItems] = new Array().fill([]);
    this.appService.getTrainingListForReportFroDynamic("all", this.draftTraining.trainingId).subscribe((row: any) => {
      this.rowList = row;
      this.appService.getTrainingListForReportFroDynamicHedding("all").subscribe((header: any) => {
        this.headerList = header;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.rowList.length;
        this.totalPages = Math.ceil(this.rowList.length / this.itemsPerPage);
        this.setPage(1, 0);
        this.isProcessing = false;
        this.visibleAssignedGroupPopup = this.dialog.open(this.assignedGroupPopup, this.assignedGroupConfig);
      })
    })
  }

  public setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.rowList.length, page, this.perPage, targetpage);
    if (this.rowList.length > 0) {
      this.pagedItems = this.rowList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  public paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  public cancelAssignedGroupsPopup(): void {
    this.visibleAssignedGroupPopup.close();
  }

  public searchTraining(): void {
    this.resetSearchTrainingPopup();
    this.popupTitle = "Assign Training";
    this.visibleSearchTrainingPopup = this.dialog.open(this.searchTrainingPopup, this.searchTrainingConfig);
  }

  public getTrainings(): void {
    this.isProcessing = true;

    const obj = {
      trainingName: this.searchByTrainingName ?? null,
      trainingCode: this.searchByTrainingCode ?? null,
      category: this.searchByCategory ?? null,
      language: this.searchByLanguage ?? null,
      ...this.selectedTrainingCriteria == 'Multiple trainings → One group' && { groupId: this.training.groupId },
      excludeExpiredTrainings: 'Y'
    };

    this.appService.searchTrainingsByCondition(obj).subscribe((response: any) => {
      this.trainingsList = response?.sort((m: { trainingName: string; }, n: { trainingName: string; }) => m?.trainingName?.trim()?.localeCompare(n?.trainingName?.trim())) ?? [];
      this.isProcessing = false;
    })
  }

  public onParentCheckBoxChanged(e: any): void {
    if (e.target.checked) {
      this.tempTrainingArray = [];
      this.onParentChecked();
    } else {
      this.parentCheckBox = false;
      this.onParentUnChecked();
    }
  }

  public onParentChecked(): void {
    for (const training of this.trainingsList) {
      training.childCheckBox = true;
      this.tempTrainingArray.push({ trainingId: training.trainingId, trainingName: training.trainingName, version: training.version });
    }
  }

  public onParentUnChecked(): void {
    this.trainingsList.every((training: any) => {
      training.childCheckBox = false; return true;
    })
    this.tempTrainingArray = [];
  }

  public onChildCheckBoxChanged(e: any, childData: any, idx: any): void {
    if (e.target.checked) {
      childData.childCheckBox = true;
      this.onChildChecked(childData);
    } else {
      childData.childCheckBox = this.parentCheckBox = false;
      this.onChildUnchecked(childData);
    }
  }

  public onChildChecked(checked: any): void {
    if (!this.trainingArray?.some((training: any) => training.trainingId === checked.trainingId)) {
      this.tempTrainingArray.push({ trainingId: checked.trainingId, trainingName: checked.trainingName, version: checked.version })
    }

    if (this.trainingsList?.every((user: any) => user.childCheckBox)) this.parentCheckBox = true;
  }

  public onChildUnchecked(unchecked: any): void {
    const removal = this.tempTrainingArray?.findIndex((removable: any) => removable.trainingId == unchecked.trainingId);
    if (removal > -1) this.tempTrainingArray?.splice(removal, 1);
  }

  public onChecked(e: any, data: any): void {
    this.trainingsList.every((item: any) => { if (item.childCheckBox) { item.childCheckBox = false; } return true; })

    if (e.target.checked) {
      data.childCheckBox = true;
      this.draftTraining = data;
    } else {
      data.childCheckBox = false;
      this.draftTraining = {};
    }
  }

  public selectTraining(): void {
    if (this.selectedTrainingCriteria == 'One training → Multiple groups') {
      this.training.trainingName = this.draftTraining.trainingName;
      this.visibleSearchTrainingPopup.close();
    } else if (this.selectedTrainingCriteria == 'Multiple trainings → One group') {
      if (this.tempTrainingArray.length > 50) {
        this.showSnackBar("A maximum of 50 trainings can be assigned at once!", 'E');
      } else {
        this.training.trainingName = this.tempTrainingArray.map((training: any) => training.trainingName).join(',');
        this.trainingArray = this.tempTrainingArray;
        this.visibleSearchTrainingPopup.close();
      }
    }
    setTimeout(() => this.onNgModelChange(this.training.trainingName, 'training-name'));
  }

  public cancelSearchTrainingPopup(): void {
    this.visibleSearchTrainingPopup.close();
  }

  private fieldValidation(elementIds: string[]): void {
    for (const elementId of elementIds) {
      const element = document.getElementById(elementId) as HTMLInputElement | null;
      element && (element.style.color = 'red');
    }
  }

  responses: any[] = [];
  public assignTraining(): void {

    const x = this.selectedTrainingCriteria;

    const validations = [
      { condition: !this.training.trainingName, id: 'training-name' },
      { condition: ((x == 'Multiple trainings → One group' && !this.training.groupId) || (x == 'One training → Multiple groups' && !this.selectedGroupIds.length)), id: 'group' },
      { condition: !this.training.trainingLevel, id: 'level' },
      { condition: this.training.overdueQaApprovalReqd && !this.selectedQaUsers.length, id: 'qa' },
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);
    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.showSnackBar("Please enter mandatory fields!", 'E');
      return;
    }

    this.isProcessing = true;
    this.responses = [];
    from(x == 'Multiple trainings → One group' ? this.trainingArray : this.selectedGroupIds) /* 'from' converts the array into an observable stream */
      .pipe(
        concatMap((training: any, index: number) => { /* 'concatMap' ensures that the next API call does not start until the current one is complete */

          let obj: { [key: string]: any };

          obj = {
            ...this.training,
            groupId: x == 'Multiple trainings → One group' ? this.training.groupId : training.valueExp,
            trainingId: x == 'Multiple trainings → One group' ? training.trainingId : this.draftTraining.trainingId,
            trainingName: x == 'Multiple trainings → One group' ? training.trainingName : this.draftTraining.trainingName,
            version: x == 'Multiple trainings → One group' ? training.version : this.draftTraining.version,
            trainingLevel: this.training.trainingLevel,
            escalate: this.training.escalate ? 'Y' : 'N',
            repeatTraining: this.training.repeatTraining ? 'Y' : 'N',
            allowToReviewResults: this.training.allowToReviewResults ? 'Y' : 'N',
            showAnswersAtReview: this.training.showAnswersAtReview ? 'Y' : 'N',
            overdueRmApprovalReqd: this.training.overdueRmApprovalReqd ? 'Y' : 'N',
            overdueQaApprovalReqd: this.training.overdueQaApprovalReqd ? 'Y' : 'N',
            listOfQaUsers: this.training.overdueQaApprovalReqd ? this.selectedQaUsers.map(String).join(',') : null,
            repeatIntervalUnit: this.training.repeatIntervalUnit ?? null
          }

          return this.appService.createTmsGroupTraining(obj).pipe(
            tap((Response: any) => { /* 'tap' is an operator used to perform side effects for debugging or performing actions without altering the data flowing through the observable stream */
              /* Store the response after the API call */
              this.responses[index] = {
                training: x == 'Multiple trainings → One group' ? training.trainingName : this.draftTraining.trainingName,
                response: { result: this.sanitizeResult(Response.result), resultType: Response.resultType },
                group: x == 'Multiple trainings → One group' ? this.selectedGroupName : training.displayExp
              };
            }),
            /* Ensure the observable emits a value for next() */
            concatMap(() => of(training))
            /* 'of(setting)' creates an observable that emits the current setting after the API call is complete.
               This observable is processed by the from pipeline and triggers the next handler for every iteration */
          );
        })
      )
      .subscribe({
        next: (item) => {
          console.log('Processed an item:', item); /* Logs the processed item where this next is triggered by of(setting) */
        },
        complete: () => {
          console.log('All API calls have been processed');
          console.log('Responses:', this.responses); /* Log the final responses array */
          this.isProcessing = false;
          this.visibleAssignPopup.close();
          this.popupTitle = "Assigned Training Results";
          this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
        },
        error: (error) => {
          this.isProcessing = false;
          console.error('Error occurred:', error);
        },
      });

  }

  private sanitizeResult(message: string): string {
    return (message.includes("ORA") && message.includes(":")) ? message.replaceAll(/ORA\s*-\s*\d*\s*:/g, '') : message;
  }

  @ViewChild('resultPopup', { static: true }) resultPopup: TemplateRef<any>;
  private visibleResultPopup: MatDialogRef<TemplateRef<any>>;

  private readonly resultPopupConfig: MatDialogConfig = {
    width: 'auto',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  public cancelResultPopup(): void {
    this.visibleResultPopup.close();
  }

  public closeAssignPopup(): void {
    this.visibleAssignPopup.close();
    this.popupClosed.emit();
  }

  private showSnackBar(message: string, type: string): void {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  viewModel: any = null;
  viewPopupTitle: string = '';
  @ViewChild('viewPopup', { static: true }) viewPopup: TemplateRef<any>;
  visibleViewPopup: MatDialogRef<TemplateRef<any>>;

  private readonly viewPopupConfig: MatDialogConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  public openViewPopup(popupFor: string): void {
    this.viewPopupTitle = popupFor;
    if (popupFor == 'Training(s)') {
      this.viewModel = this.training.trainingName;
    } else {
      this.viewModel = this.selectedGroupIds.map((id: any) => id.displayExp)?.join(',');
    }
    this.visibleViewPopup = this.dialog.open(this.viewPopup, this.viewPopupConfig);
  }

  public closeViewPopup(): void {
    this.visibleViewPopup.close();
  }

}
